import { createClient } from '@ignite-systems/auth-service-api'
import { getCustomerPortalUrl } from './customer-portal'
import useAuthServiceStore from './stores/auth-service-store'

export function getAuthServiceConfig(turnstileToken?: string) {
  const authServiceStore = useAuthServiceStore()
  const client = createClient(new URL('/api/trpc', window.injectedEnv.FRONTEND_AUTH_SERVICE_URL).toString(), { turnstileToken })
  return {
    enabled: window.injectedEnv.FRONTEND_AUTH_SERVICE_ENABLED === 'true',
    endpoint: window.injectedEnv.FRONTEND_AUTH_SERVICE_URL,
    getAuthProspectToken: () => client.auth.getAuthProspectToken.query(),
    exchangeAuthProspectToken: (token: string) => client.auth.exchangeAuthProspectToken.query({ token }),
    getAggAuth: (guid: string) => client.auth.getAuthTokenForAgg.query({ guid }),
    getDeepLinkAuth: (guid: string) => client.auth.getAuthTokenForDeepLink.query({ guid }),
    setToken: (token: string, type: Parameters<typeof authServiceStore.setToken>['1']) => {
      authServiceStore.setToken(token, type)
    },
    clearToken: () => {
      authServiceStore.clearToken()
    },
    type: authServiceStore.type,
    token: authServiceStore.token,
    authHeader: authServiceStore.token ? `Bearer ${authServiceStore.token}` : undefined,
    handOffSessionToNewCustomerPortal: (path: string) => {
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = new URL('/api/auth-redirect', getCustomerPortalUrl()).toString()

      const data = {
        authType: authServiceStore.$state.type! === 'auth' ? 'auth' : 'auth_prospect',
        authToken: authServiceStore.$state.token!,
        path,
      }

      Object.entries(data).forEach(([key, value]) => {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value = value
        form.appendChild(input)
      })

      document.body.appendChild(form)
      form.submit()
    },
  }
}
